import React from 'react'
import Dropdown from '../dropdown'
import styled from 'styled-components'
import './styles.css'
import {ButtonSecondary} from "../button";

const TabActionWrapper = styled.div`

`

const Button = styled(ButtonSecondary)`
	display: flex;
	flex-flow: row;
	justify-content: space-around;
	align-items: center;
	gap: 8px;
	padding: 8px 24px;
	height: 32px;
	color: var(--it-text-white);
	background-color: inherit;
		
	& > [data-icon] {}
	& > [data-title] {}
`

export const TabAction = ({title, icon, dropdownContent, onClick}) => {
	const btn = (
		<Button className={`tab rounded-lg flex flex-row items-center justify-around`} onClick={onClick} >
			{icon} <span>{title}</span>
		</Button>
	)
	return <>
		<TabActionWrapper className="flex-none">
			{
				dropdownContent
					? <Dropdown
						width="w-full"
						button={btn}
						dropdownToggleClass="btn btn-default btn-outlined btn-outlined-indigo">
						{dropdownContent}
					</Dropdown>
					: btn
				}
		</TabActionWrapper>
	</>
}
